import './App.css';
import { Provider } from "react-redux"; 
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from './store';
import HomePage from './pages/Home/home';
import ServicePage from './pages/Services/service';
import AboutPage from './pages/AboutUs/about';
import ContactForm from './pages/ContactForm/contactForm';
import CareerPage from './pages/Career/career';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <div className="App">
          <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
              // transition={Bounce}
              toastStyle={{
                zIndex: 99999,
                backgroundColor: "#181818",
              }}
            />


            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/service" element={<ServicePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/career" element={<CareerPage />} />
              <Route path="/contact-form" element={<ContactForm />} />
            </Routes>
          </div>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
